import { render, staticRenderFns } from "./CustomProcessPanel.vue?vue&type=template&id=0a8a7d63&"
import script from "./CustomProcessPanel.vue?vue&type=script&lang=js&"
export * from "./CustomProcessPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomProcessPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports